/* NAO Infinite Scroll v5 – V42
   - Append uniquement les cartes produit
   - Garde le sentinel actif tant qu'une page suivante existe
   - Aucun faux resize/scroll apres insertion
*/
(function () {
  if (!document.body.classList.contains('template-collection')) return;

  var grid =
    document.getElementById('append-data-here') ||
    document.querySelector('#Collection .nao-collection-grid') ||
    document.querySelector('.nao-collection-grid');

  var loadMore = document.getElementById('load-more-products');
  var loader = document.getElementById('infinite-scroll-loader');

  if (!grid || !loadMore) return;

  var isLoading = false;
  var observer = null;

  function ensureAjaxUrl(url) {
    if (!url) return '';
    if (url.indexOf('view=ajax') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?view=ajax' : '&view=ajax');
  }

  function showLoader(on) {
    if (!loader) return;
    loader.style.display = on ? 'block' : 'none';
  }

  function hasNextPage() {
    return !!loadMore.getAttribute('data-next-page');
  }

  async function loadNextPage() {
    if (isLoading) return;

    var rawNext = loadMore.getAttribute('data-next-page');
    if (!rawNext) {
      showLoader(false);
      if (observer) observer.disconnect();
      return;
    }

    var nextUrl = ensureAjaxUrl(rawNext);
    if (!nextUrl) return;

    isLoading = true;
    showLoader(true);

    try {
      var res = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newItems = doc.querySelectorAll('li.nao-collection-item');
      var added = 0;

      if (newItems && newItems.length) {
        newItems.forEach(function (li) {
          grid.appendChild(document.importNode(li, true));
          added += 1;
        });
      }

      var newLoadMore = doc.getElementById('load-more-products');
      var newNext = newLoadMore ? newLoadMore.getAttribute('data-next-page') : '';

      if (newNext) {
        loadMore.setAttribute('data-next-page', newNext);
        showLoader(true);
      } else {
        loadMore.removeAttribute('data-next-page');
        showLoader(false);
        if (observer) observer.disconnect();
      }

      if (added) {
        document.dispatchEvent(new CustomEvent('nao:collection:appended', {
          detail: { count: added }
        }));
      }
    } catch (e) {
      console.error('[NAO] infinite scroll error', e);
      showLoader(false);
    } finally {
      isLoading = false;
      if (!hasNextPage()) showLoader(false);
    }
  }

  var sentinel = loader || loadMore;

  if ('IntersectionObserver' in window && sentinel) {
    showLoader(hasNextPage());
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { root: null, rootMargin: '600px 0px', threshold: 0.01 });
    observer.observe(sentinel);
  } else {
    window.addEventListener('scroll', function () {
      if (isLoading) return;
      if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 600) {
        loadNextPage();
      }
    }, { passive: true });
  }
})();
